import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { Text, Image, Divider, VStack, HStack } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util'
import StoreCoinSvg from '@images/store_coin.svg'
import { paymentListAtom, listIndexAtom } from '@!/atoms/paymentAtom'

export const CoinPaymentHeader = () => {
  const [coinCount, setCoinCount] = useState(null)
  const [price, setPrice] = useState(null)

  const [paymentList] = useAtom(paymentListAtom)
  const [listIndex] = useAtom(listIndexAtom)

  useEffect(() => {
    if (listIndex >= 0 && listIndex < paymentList.length) {
      setCoinCount(paymentList[listIndex][0])
      setPrice(paymentList[listIndex][1])
    }
  }, [paymentList, listIndex])

  return (
    <VStack w="100%" spacing="0">
      <HStack w="100%" p="4" justify="space-between">
        <Text fontWeight="bold">購入コイン数</Text>
        <HStack>
          <Image src={buildAssetUrlString(StoreCoinSvg)} w="18px" alt="コイン" />
          <Text>{coinCount}</Text>
        </HStack>
      </HStack>
      <Divider />
      <HStack w="100%" p="4" justify="space-between">
        <Text fontWeight="bold">お支払い金額</Text>
        <Text>￥{price?.toLocaleString()}(税込)</Text>
      </HStack>
      <Divider />
    </VStack>
  )
}
